import AlertBox from "components/global/AlertBox";
import Loader from "components/global/Loader";
import Logo from "components/global/Logo";
import Spacer from "components/global/Spacer";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom"
import { socialLogin } from "api";
import styled from "styled-components";
import { showAlert } from "utils/utils";
import usePageTitle from "hooks/usePageTitle";

const Wrapper = styled.div`
  width: 100vw;
  height: 100vh;

  .inner {
    padding: 24px;
  }

  .header {
    margin-bottom: 30vh;
    border-bottom: 1px solid #eaeaea;
  }

  .heading {
    color: var(--grey_1);
    width: 39.6rem;
  }

  .subHeading {
    color: var(--body_text);
    width: 58.3rem;
  }

  .verifyEmailImg {
    display: block;
    width: 14.8rem;
    margin: 0 auto;
  }

  @media screen and (max-width: 768px) {
    .heading {
      font-size: 24px;
      line-height: 32px;
      width: 28.6rem;
    }

    .subHeading {
      font-size: 18px;
      line-height: 24px;
      width: 100%;
    }
  }
`;

const AuthRedirect = () => {
  usePageTitle("Social Login")
  const [loading, setLoading] = useState(true);
  const { search } = useLocation();
  const { provider } = useParams();
  const router = useHistory();

  const handleRequest = async () => {
    try {
      const res = await socialLogin(provider, search);

      if (res?.data?.status === false) {
        showAlert({
          msg: "Something went wrong. Try again",
          type: "danger",
        });
      }
      
      router.push("/sign-in");
      setLoading(false);
    } catch (e) {
      console.log(e);
      showAlert({
        msg: "An error occurred",
        type: "danger",
      });
      setLoading(false);
      router.push("/sign-in");
    }
  };

  useEffect(() => {
    handleRequest();
    // eslint-disable-next-line
  }, []);

  return (
    <Wrapper>
      <AlertBox />
      <div className="flexColumn alignCenter justifyCenter fullWidth header">
        <Spacer y={2.4} />
        <Logo />
        <Spacer y={2.4} />
      </div>
      <div className="flexColumn alignCenter inner">
        <Spacer y={2.4} />
        {loading && <Loader />}
        {/* <p className="l1-large subHeading textCenter">
          {text}
        </p> */}
      </div>
    </Wrapper>
  );
};

export default AuthRedirect;
